import { RiskProfilePage } from "./riskProfile";

export const RiskProfile = RiskProfilePage;
